import { render, staticRenderFns } from "./TransgressiveUsers.vue?vue&type=template&id=620ff7b8&scoped=true&"
import script from "./TransgressiveUsers.vue?vue&type=script&lang=js&"
export * from "./TransgressiveUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620ff7b8",
  null
  
)

export default component.exports